import { Component } from '@angular/core';

@Component({
  selector: 'tsv-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {

  fanShopUrl: string = 'https://tsvtravemuende.fan12.de/';

}
